import { DownOutlined } from '@ant-design/icons';
import { Popover as AntPopover } from 'antd';
import styled, { css } from 'styled-components';

export const Popover = styled(AntPopover)``;

export const SelectTrigger = styled.div<{
  $disabled?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 11px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  min-height: 32px;
  min-width: 120px;
  transition: border-color 0.2s;
  user-select: none;

  &:hover {
    border-color: #4096ff;
  }

  ${({ $disabled }) =>
    $disabled &&
    css`
      background: #f5f5f5;
      cursor: not-allowed;
      opacity: 0.65;

      &:hover {
        border-color: #d9d9d9;
      }
    `}
`;

export const SelectText = styled.span<{ $isPlaceholder?: boolean }>`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ $isPlaceholder }) => ($isPlaceholder ? '#bfbfbf' : 'inherit')};
  font-size: 14px;
`;

export const DownIcon = styled(DownOutlined)`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.25);
  margin-left: 8px;
  flex-shrink: 0;
`;

export const DropdownContent = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 160px;
  padding: 4px 0;
`;

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 0 4px;
`;

export const GroupLabel = styled.span`
  font-weight: 600;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.88);
`;

export const CheckboxRow = styled.div`
  padding-left: 4px;
`;

export const Divider = styled.hr`
  margin: 0;
  border: none;
  border-top: 1px solid #f0f0f0;
`;
